/**
 * @generated SignedSource<<de2081dfe455f186b10d327c64586c25>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type JobStatusEnum = "CANCELLED" | "COMPLETED" | "RUNNING" | "SCHEDULED";
import { FragmentRefs } from "relay-runtime";
export type TimerContentRightDetailsFragment$data = {
  readonly actualStartTime: any | null | undefined;
  readonly actualStopTime: any | null | undefined;
  readonly durations: {
    readonly dynamicDurationMinutes: number | null | undefined;
    readonly plannedDurationMinutes: number | null | undefined;
  } | null | undefined;
  readonly estimatedStartTime: any | null | undefined;
  readonly estimatedStopTime: any | null | undefined;
  readonly estimates: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly estimate: Date | null | undefined;
        readonly id: string;
        readonly insertedAt: Date | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly plannedStart: any | null | undefined;
  readonly plannedStop: any | null | undefined;
  readonly status: JobStatusEnum | null | undefined;
  readonly " $fragmentType": "TimerContentRightDetailsFragment";
};
export type TimerContentRightDetailsFragment$key = {
  readonly " $data"?: TimerContentRightDetailsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimerContentRightDetailsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimerContentRightDetailsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Durations",
      "kind": "LinkedField",
      "name": "durations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dynamicDurationMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "plannedDurationMinutes",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualStartTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualStopTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "estimatedStartTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "estimatedStopTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedStop",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 20
        }
      ],
      "concreteType": "EstimateConnection",
      "kind": "LinkedField",
      "name": "estimates",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EstimateEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Estimate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "estimate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "insertedAt",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": "estimates(first:20)"
    }
  ],
  "type": "Job",
  "abstractKey": "__isJob"
};

(node as any).hash = "55f656537847d2470495d254861b1536";

export default node;
